import { autoinject } from 'aurelia-framework';
import { TemperatureBaseDevice } from "./temperature-base-device";
import { Store } from "aurelia-store";
import { IState } from "../../../store/state";
import { Api } from "../../../services/api";
import { Device } from "../../../models/device";
import { I18N } from "aurelia-i18n";

@autoinject
export class UrsalinkSoilMoisture extends TemperatureBaseDevice {

	constructor(store: Store<IState>, api: Api, i18n: I18N) {
		super(store, api, i18n);
	}


	activate(device: Device) {
		this.device = device;
		//this.device.data = {
		//	"soilTemperature": 20.9,
		//	"soilMoisture" : 55,
		//	"electricalConductivity": 1,
		//	"battery": 3600,
		//	"rssi": -62,

		//};
		//this.device.styles = {
		//	"rssi": "green",
		//	"battery": "green"
		//};
		//this.device.properties = {
		//	"nominalVoltage": {
		//		"name": "nominalVoltage",
		//		"value": "3600",
		//		"type": null
		//	},
		//	"battery": {
		//		"name": "battery",
		//		"value": "2000,3500",
		//		"type": "BatteryRule"
		//	},
		//	"rssi": {
		//		"name": "rssi",
		//		"value": "-120,-90,-60,-30",
		//		"type": "RssiRule"
		//	},
		//	"temperature": {
		//		"name": "temperature",
		//		"value": "1.67,5.56,42.22,50",
		//		"type": "TemperatureRule"
		//	}
		//}
	}

	attached() {
		if (this.tooltip) {
			//this.tooltip.position = "bottom";
			this.tooltip.html = this.buildToolTip();
		}

	}
}